module.exports = __webpack_public_path__ + "static/media/Passport Page Runout.25be457a.jpg";